import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NpsHelpModalComponent } from './nps-help-modal.component';
import { ButtonModule } from '@xref/xref-lib';



@NgModule({
  declarations: [NpsHelpModalComponent],
  imports: [
    CommonModule,
    ButtonModule
  ],
  exports: [NpsHelpModalComponent]
})
export class NpsHelpModalModule { }
